import { t } from "@/i18n-js/instance";
import { EmailHubFreePeriodBanner } from "@/react/components/shared/EmailHubFreePeriodBanner";
import { useIsConnectCoreEnabled } from "@/react/hooks/useIsConnectCoreEnabled";
import { usePunditUserContext } from "@circle-react/contexts";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { useEmailHubBilling } from "@circle-react/hooks/useEmailHubBilling";
import { NavGroup } from "../NavGroup";
import { FooterWrapper } from "./FooterWrapper";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const MemberLinks = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isAccessGroupsEnabled = Boolean(
    currentCommunitySettings?.access_groups_enabled,
  );
  const { isInFreePeriod } = useEmailHubBilling();
  const isConnectCoreEnabled = useIsConnectCoreEnabled();

  const links: Link[] = [
    {
      label: t("settings_nav_v3.members.manage"),
      path: settingsNavPathV3.members.manage,
      exact: false,
    },
  ];

  if (isAccessGroupsEnabled) {
    links.push({
      label: t("settings_nav_v3.members.access_groups"),
      path: settingsNavPathV3.members.access_groups,
      exact: true,
    });
  }

  if (isConnectCoreEnabled) {
    links.push({
      label: t("settings_nav_v3.connect.title"),
      path: settingsNavPathV3.connect.overview,
      exact: true,
      isNewFeature: true,
    });
  }

  links.push(
    ...[
      {
        label: t("settings_nav_v3.members.segments"),
        path: settingsNavPathV3.members.segments,
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.bulk_logs"),
        path: settingsNavPathV3.members.bulk_logs,
        exact: true,
      },
      {
        label: t("settings_nav_v3.members.invitation_links"),
        path: settingsNavPathV3.members.invitation_links,
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.onboarding"),
        path: settingsNavPathV3.members.onboarding,
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.member_tags"),
        path: settingsNavPathV3.members.member_tags,
        exact: false,
      },
      {
        label: t("settings_nav_v3.members.profile_fields"),
        path: settingsNavPathV3.members.profile_fields,
        exact: true,
      },
      {
        label: t("settings_nav_v3.members.gamification"),
        path: settingsNavPathV3.members.gamification,
        exact: true,
      },
      {
        label: t("settings_nav_v3.members.activity_logs"),
        path: settingsNavPathV3.members.activity_logs,
        exact: true,
      },
    ],
  );

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.members.label")}>
        {links.map(link => (
          <SubNavLinkItem
            key={link.label}
            label={link.label}
            path={link.path}
            isDisabled={link.isDisabled}
            exact={link.exact}
            isNewFeature={link.isNewFeature}
          />
        ))}
        {isInFreePeriod && (
          <FooterWrapper>
            <EmailHubFreePeriodBanner />
          </FooterWrapper>
        )}
      </NavGroup.Content>
    </NavGroup>
  );
};
